import { AuthUserGroupOptions } from './../../share/authenticate/auth-if';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'isSetUgOptionPipe'
})
export class IsSetUgOptionPipe implements PipeTransform {
  transform(value: AuthUserGroupOptions[], expectedUgOption: string, expectUgOptionValue: string = '1'): boolean {
    return value.some(opt => opt.option === expectedUgOption && opt.option_value === expectUgOptionValue);
  }
}
